// src/features/home/api.js

import { handleResponse } from "../../utils/apiHandler";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('access_token')}`
});

const API_URL = process.env.REACT_APP_API_ENDPOINT;

export async function getHomeData() {
  const url = `${API_URL}/api/employee/home/`;
  const res = await fetch(url, { headers: getAuthHeaders() });
  return handleResponse(res, 'Failed to fetch home data');
}